import { Text, View, Image, Textarea } from 'components';
import Base, { Config } from 'components/eswj/Base';
import React from 'react';
import Uploader from 'components/Uploader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';
import cx from 'classnames'


interface State {
  content: string
  imgs: string[]
  video: string
  imgsLength: number
}

const TOASTPARAMS = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 1500,
  closeButton: false,
}

export default class Vip extends Base<any, State>  {
  public config: Config = {
    navigationBarTitleText: '二手机信息'
  };

  public state: State = {
    content: '',
    imgs: [],
    video: '',
    // video: "https://assets.gongji58.com/2020-11-25/kk1dco193l1606273192.mp4",
    // imgs: ["https://assets.gongji58.com/2020-11-25/6hzwxhb8dh1606271966.png", "https://assets.gongji58.com/2020-11-25/cr5l4mtgwc1606271967.png", "https://assets.gongji58.com/2020-11-25/4uif0cxurm1606271967.png", "https://assets.gongji58.com/2020-11-25/t2qyr6ruj01606271967.png", "https://assets.gongji58.com/2020-11-25/96bzrfpydw1606271967.png", "https://assets.gongji58.com/2020-11-25/z5bju8o8gs1606271967.png"],
    imgsLength: 12
  };


  public async didMount() {
    // await this.getUserInfo();

  }

  public render() {
    const { content, imgs, imgsLength, video } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>

        <View className={styles.header} style={{display: 'none'}}>
          <View className={styles.le}>
            <Image src={'https://assets.gongji58.com/2020-11-25/6hzwxhb8dh1606271966.png'} className={styles.img} />
          </View>
          <View className={styles.ri}>
            <View className={styles.h2}>浙江诚信二手挖机</View>
            <View className={styles.h5}>注册手机：18812341234
              <View className={styles.tag}>身份已认证</View>
            </View>
            <View className={styles.p}>有效期：11月27日~12月27日
              <View className={styles.span}>点此续费 》</View>
            </View>
          </View>
        </View>
        <View className={styles.sec}>
          <View className={styles.title}>设备介绍</View>
          <View className={styles.inner}>
            <Textarea 
              className={styles.ta}
              value={content}
              placeholder='请填写设备的品牌、型号、出厂年份、 使用时长等详细情况'
              name="content"
              valueChange={this.textareaChange.bind(this)}
            />
          </View>
        </View>
        <View className={styles.sec}>
          <View className={styles.title}>设备照片</View>
          <View className={styles.inner}>
            <View className={styles.uploaderBox}>
              {imgs.map((res, ind) => (
                <View className={styles.imgBox} key={res}>
                  <Image src={res} className={styles.img} />
                  <View className={styles.close} onClick={this.deleteImg.bind(null, ind)}>
                    <Image src={this.assets.eswj.closeG} className={styles.ico} />
                  </View>
                </View>
              ))}
              {imgs.length < imgsLength && 
                <View className={styles.imgBox}>
                  <Uploader onChange={this.handleImagesChange} max={imgsLength - imgs.length}/>
                </View>
              }
              {video? (
                <View className={styles.videoBox}>
                  <video src={video} className={styles.video}></video>
                  <View className={styles.close} onClick={this.deleteVideo}>
                    <Image src={this.assets.eswj.closeG} className={styles.ico} />
                  </View>
                </View>
              ): (
                <View className={styles.imgBox}>
                  <Uploader onChange={this.handleVideoChange} max={1} type="video"/>
                </View>
              )}
              
            </View>
          </View>
        </View>


        <View className={styles.button} onClick={this.handleSubmit}>提交</View>
        
      </View>
    );
  }

  private textareaChange = (name:'content', e) => {
    // console.log("aa",name, e)
    this.setState({
      [name]:  e.target.value
    })
  }

  private handleImagesChange = e => {
    const { imgs } = this.state
    this.setState({
      imgs: [...imgs, ...e]
    })
    // console.log([...imgs, ...e])
  }

  private deleteImg = (num) => {
    let { imgs } = this.state
    imgs.splice(num, 1)
    this.setState({
      imgs: [...imgs]
    })
  }
  
  private handleVideoChange = e => {
    this.setState({
      video: e[0]
    })
  }

  private deleteVideo = () => {
    this.setState({
      video: ''
    })
  }

  private handleSubmit = async() => {
    const { content, imgs, video} = this.state
    if(!content || content.length < 15){
      toast.error("至少填写15字设备介绍!", TOASTPARAMS)
      return;
    }
    if(!imgs || imgs.length < 1){
      toast.error("请上传照片!", TOASTPARAMS)
      return;
    }


    let search = this.props.location.search || ''
    let searchArr = search.split('?')
    let params:any = {}
    searchArr.length > 0 && searchArr.map(res => {
      if(!!res) {
        let arr = res.split('=')
        params[arr[0]] = arr[1]
      }
    })
    if(!params.sid) {
      toast.error("缺少sid!", TOASTPARAMS)
      return;
    }


    const res = await this.apiClient.base.pubCarFast({
      content, 
      sid: params.sid,
      imgs, 
      video
    })
    if(res.status == 10000) {
      toast.success('上传成功！', TOASTPARAMS)
      this.setState({
        content: '', 
        imgs: [], 
        video: ''
      })
    }else {
      toast.error(res.msg, TOASTPARAMS)
    }
  }
}
